<template>
  <div
    v-editable="blok"
    class="CustomerServiceBlock layout-container"
    :class="[desktopWidth('md'), blockPaddingTop('md'), blockPaddingBottom('md')]"
  >
    <div
      v-if="blok.headingTitle || blok.headingButtonText"
      class="flex flex-row flex-wrap justify-between items-center gap-8 mb-16"
      :class="{'flex-col text-center' : blok.headingAlign === 'center'}"
    >
      <component :is="blok.headerTag ?? 'h2'" class="type-headline-xl"> {{ blok.headingTitle }}</component>

      <Nuxt-link
        :to="$sbLinkFix(blok.headingButtonLink)"
        :target="$sbLinkTarget(blok.headingButtonLink)"
      >
        <div
          v-if="blok.headingButtonText"
          class="btn btn--primary"
          :class="{
            'btn--secondary': blok.headingButtonStyle === 'secondary',
            'btn--underline': blok.headingButtonStyle === 'underline',
          }"
        >
          {{ blok.headingButtonText }}
        </div>
      </Nuxt-link>
    </div>

    <div
      class="grid gap-8"
      :class="gridColsClass"
    >
      <component
        :is="box.component"
        v-for="box in blok.boxes"
        :key="box._uid"
        :blok="box"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { DatasourceHeadlineTypes, StoryBlokLink } from '#constants/types/storyblok';

import useVisualAppearancePlugin from '~/composables/useVisualAppearancePlugin';

interface Props {
  title: string;
  text: string;
  boxes: any[];
  // Heading fields
  headingTitle: string;
  headerTag?: DatasourceHeadlineTypes;
  headingButtonText: string;
  headingButtonLink: StoryBlokLink;
  headingButtonStyle: 'primary' | 'secondary' | 'underline';
  headingAlign: 'left' | 'center';
}

const props = defineProps<{
  blok: Props,
}>();

const gridColsClass = computed(() => {
  const numBoxes = props.blok.boxes.length;
  // Set the class based on the number of items
  if (numBoxes === 5) {
    return 'grid-cols-2 desk:grid-cols-5';
  } else {
    return 'grid-cols-2 desk:grid-cols-4';
  }
});

const { desktopWidth, blockPaddingTop, blockPaddingBottom } = useVisualAppearancePlugin(props);

</script>
